/*
 * @Author: hai.zhang
 * @LastEditors: Gexiaolei gxiaolei@163.com
 * @Date: 2019-08-19 10:12:38
 * @LastEditTime: 2022-08-01 14:27:33
 */
export default {
  main: [
    // 商城首页
    {
      name: 'main',
      path: '/',
      component: () => import(/* webpackChunkName: "home" */'../routes/home/index.vue'),
      meta: {
        title: {
          'zh-CN': '商城首页',
          en: '商城首页_en',
          jp: '商城首页_jp'
        },
        loginCheck: false,
        spmB: 'b1',
        pageTextCode: '1f667201b54880c9',
        isLocolLogin: true
      }
    },
    {
      name: 'login-transfer',
      path: '/member/login-transfer',
      component: () => import(/* webpackChunkName: "member-reset" */'../routes/member/login-transfer/index.vue'),
      meta: {
        title: {
          'zh-CN': '登录中转',
          en: '登录中转_en',
          jp: '登录中转_jp'
        },
        loginCheck: false,
        hideSideFixed: true,
        avoidLogin: true,
        spmB: 'b624',
        isNewHeader: false,
        basics: true,
        noNotice: true
        // spmB: 'b646',
      }
    },
    // 领用利旧商城
    {
      name: 'store',
      path: '/store/:id',
      component: () => import(/* webpackChunkName: "home" */'../routes/store/index.vue'),
      meta: {
        title: {
          'zh-CN': '物资领用商店',
          en: '物资领用商店_en',
          jp: '物资领用商店_jp'
        },
        spmB: 'b438',
        supplierInfo: true
      }
    },
    // 领用利旧商城搜本站
    {
      name: 'store-shop',
      path: '/store-shop',
      component: () => import(/* webpackChunkName: "info" */'../routes/list/store-shop/index.vue'),
      meta: {
        title: {
          'zh-CN': '物资领用商店',
          en: '物资领用商店_en',
          jp: '物资领用商店_jp'
        },
        spmB: 'b439',
        supplierInfo: true,
        i18nCode: 'list'
      }
    },
    // 商城频道
    {
      name: 'channel',
      path: '/channel/:id',
      component: () => import(/* webpackChunkName: "home" */'../routes/channel/index.vue'),
      meta: {
        title: {
          'zh-CN': '商城频道',
          en: '商城频道_en',
          jp: '商城频道_jp'
        },
        loginCheck: false,
        spmB: 'b2'
      }
    },
    // 商城列表
    {
      name: 'list',
      path: '/list',
      component: () => import(/* webpackChunkName: "list" */'../routes/list/search-list/index.vue'),
      meta: {
        title: {
          'zh-CN': '商城列表',
          en: '商城列表_en',
          jp: '商城列表_jp'
        },
        loginCheck: false,
        spmB: 'b3'
      }
    },
    // 商品比价列表
    {
      name: 'compare-price',
      path: '/compare-price',
      component: () => import(/* webpackChunkName: "list" */'../routes/list/compare-price/index.vue'),
      meta: {
        title: {
          'zh-CN': '商品比价聚合页面',
          en: '商品比价聚合页面_en',
          jp: '商商品比价聚合页面_jp'
        },
        loginCheck: false,
        spmB: 'b395',
        i18nCode: 'list'
      }
    },
    // 商品手动比价对比页面
    {
      name: 'product-compare',
      path: '/product-compare',
      component: () => import(/* webpackChunkName: "list" */'../routes/list/product-compare/index.vue'),
      meta: {
        title: {
          'zh-CN': '手动比价',
          en: '手动比价_en',
          jp: '手动比价_jp'
        },
        spmB: 'b578',
        hideBottom: true
      }
    },
    // 商品详情
    {
      name: 'info',
      path: '/info/:mallSkuId',
      component: () => import(/* webpackChunkName: "info" */'../routes/info/index.vue'),
      meta: {
        title: {
          'zh-CN': '商品详情',
          en: '商品详情_en',
          jp: '商品详情_jp'
        },
        loginCheck: false,
        spmB: 'b4',
        supplierInfo: true
      }
    },
    // 供应商聚合页
    {
      name: 'supplier-shop',
      path: '/supplier-shop',
      component: () => import(/* webpackChunkName: "info" */'../routes/list/supplier-shop/index.vue'),
      meta: {
        title: {
          'zh-CN': '供应商聚合页',
          en: '供应商聚合页_en',
          jp: '供应商聚合页_jp'
        },
        loginCheck: false,
        spmB: 'b285',
        supplierInfo: true,
        i18nCode: 'list'
      }
    },
    // 请购单-非目录化商品
    {
      name: 'req',
      path: '/req',
      component: () => import(/* webpackChunkName: "req" */'../routes/req/req.vue'),
      meta: {
        title: {
          'zh-CN': '非商城采购',
          en: '非商城采购_en',
          jp: '非商城采购_jp'
        },
        spmB: 'b7'
      }
    },
    // 采购商城 - 公告详情
    // {
    //   path: '/notice',
    //   name: 'notice',
    //   component: () => import(/* webpackChunkName: "notice" */'../routes/notice/index.vue'),
    //   meta: {
    //     title: {
    //       'zh-CN': '公告',
    //       en: '公告_en',
    //       jp: '公告_jp'
    //     },
    //     spmB: 'b19',
    //     isNewHeader: true
    //   }
    // },
    // // 帮助中心
    // {
    //   path: '/help/list',
    //   name: 'help-list',
    //   component: () => import(/* webpackChunkName: "notice" */'fe-coms/components/business/ai-service/help/list.vue'),
    //   meta: {
    //     title: {
    //       'zh-CN': '帮助中心',
    //       en: '帮助中心_en',
    //       jp: '帮助中心_jp'
    //     },
    //     spmB: 'b456',
    //     noTranslation: true,
    //     isNewHeader: true
    //   }
    // },
    // // 帮助中心详情
    // {
    //   path: '/help/detail',
    //   name: 'help-detail',
    //   component: () => import(/* webpackChunkName: "notice" */'fe-coms/components/business/ai-service/help/detail.vue'),
    //   meta: {
    //     title: {
    //       'zh-CN': '帮助中心详情',
    //       en: '帮助中心详情_en',
    //       jp: '帮助中心详情_jp'
    //     },
    //     spmB: 'b457',
    //     noTranslation: true,
    //     isNewHeader: true
    //   }
    // },
    // 企业应用免登
    {
      name: 'avoid-login',
      path: '/avoid/login',
      component: () => import(/* webpackChunkName: "avoid-login" */'../routes/member/avoid-login/index.vue'),
      meta: {
        loginCheck: false,
        hideSideFixed: true,
        avoidLogin: true,
        spmB: 'b624',
        isNewHeader: false,
        basics: true,
        noNotice: true,
        i18nCode: 'avoid-login'
      }
    },
    {
      name: 'single-login',
      path: '/single/login',
      component: () => import(/* webpackChunkName: "single-login" */'../routes/member/single-login/index.vue'),
      meta: {
        loginCheck: false,
        hideSideFixed: true,
        avoidLogin: true,
        spmB: 'b625',
        isNewHeader: false,
        basics: true,
        noTranslation: true
      }
    },
    {
      name: 'demand-portal',
      path: '/demand-portal',
      component: () => import(/* webpackChunkName: "demand-portal" */'../routes/demand/portal/index.vue'),
      meta: {
        title: {
          'zh-CN': '服务类采购专区',
          en: '服务类采购专区_en',
          jp: '服务类采购专区_jp'
        },
        loginCheck: false,
        spmB: 'b634',
        i18nCode: 'demand/demand-portal'
      }
    },
    {
      name: 'demand-submission',
      path: '/demand-submission',
      component: () => import(/* webpackChunkName: "demand-portal" */'../routes/demand/demand-submission/index.vue'),
      meta: {
        title: {
          'zh-CN': '需求提报',
          en: '需求提报_en',
          jp: '需求提报_jp'
        },
        loginCheck: false,
        spmB: 'b635',
        i18nCode: 'demand/demand-submission',
        menuCode: true
      }
    }
  ],
  field: [
    // 采购商城 - 我的商城
    {
      path: '/portal',
      name: 'portal',
      component: () => import(/* webpackChunkName: "portal" */'../routes/portal/index.vue'),
      meta: {
        title: {
          'zh-CN': '我的商城',
          en: '我的商城_en',
          jp: '我的商城_jp'
        },
        spmB: 'b18'
      }
    }
  ]
}
